import { useDispatch, useSelector } from "react-redux";
import {
    incrementPosition,
    setIsEnd,
    setLoadingReply,
    setMessages,
    setMessagesArchived,
    setIsCountTimerClose,
    resetTimer,
} from "../../../features/messagesSlice.js";
import useRequestData from "../../../hooks/useRequestData.js";
import { GREETING_MSG_PRE, KEYS } from "../../../../constants.js";
import { formatMessageDataV2 } from "../../../utils/formatData.js";

export default function RestartChatButton() {
    localStorage.removeItem(KEYS.ARCHIVEMESSAGE_TOKEN);
    localStorage.removeItem(KEYS.ARCHIVECHAT_ID);
    const dispatch = useDispatch();
    const messagesArchived = useSelector(
        (state) => state.messages.messagesArchived
    );
    const messages = useSelector((state) => state.messages.messages);
    const deviceId = useSelector((state) => state.session.deviceId);
    const position = useSelector((state) => state.messages.position);
    const autoCloseTimerId = useSelector(
        (state) => state.messages.autoCloseTimerId
    );
    const { initializeChat } = useRequestData();

    const handleRestartChat = async () => {
        dispatch(setIsEnd(false));
        clearInterval(autoCloseTimerId);
        dispatch(resetTimer());
        dispatch(setLoadingReply(true));
        dispatch(setIsCountTimerClose(false));
        dispatch;
        const restartTime = new Date().toLocaleString();
        const clearCutMessage = {
            content: `Chat restarted at ${restartTime}`,
            user_id: "system",
        };
        dispatch(
            setMessagesArchived([
                ...messagesArchived.concat(...messages, clearCutMessage),
            ])
        );
        const initChatPromise = initializeChat();
        const greetingMessage = formatMessageDataV2(
            deviceId,
            "bot",
            GREETING_MSG_PRE,
            position,
            true
        );
        dispatch(setMessages([greetingMessage]));
        dispatch(incrementPosition());
        try {
            await initChatPromise;
        } catch (error) {
            console.error("Error initializing chat:", error);
        } finally {
            dispatch(setLoadingReply(false));
        }
    };

    return <button onClick={handleRestartChat}>Restart Chat</button>;
}
